import { Button } from '@mui/material';

import { Bbar } from 'components/docked';
import { usePermissionsContext } from 'context/PermissionsContext';
import { DreFormBbarInfo } from 'pages/financeiro/dre/components';
import { useDreFormContext } from 'pages/financeiro/dre/contexts';
import { useMutateDre, useRecalculateDre } from 'pages/financeiro/dre/hooks';

export function DreFormBBar() {
    const { hasPermission } = usePermissionsContext();
    const { submitDre } = useMutateDre();
    const { recalculateValidatedDre } = useRecalculateDre();
    const { status } = useDreFormContext();

    return (
        <Bbar>
            <DreFormBbarInfo />

            <Button
                variant="contained"
                disabled={Boolean(status)}
                onClick={() =>
                    recalculateValidatedDre().then((valid) => {
                        if (valid) {
                            submitDre(false);
                        }
                    })
                }
            >
                Salvar
            </Button>

            {hasPermission(['FINANCEIRO_DRE_ENVIAR']) && (
                <Button variant="contained" disabled={Boolean(status)} onClick={() => submitDre(true)}>
                    Encerrar Estimativa de Resultado
                </Button>
            )}
        </Bbar>
    );
}
